/**
 * product-page-guard.js
 * 商品ページ専用:
 *  - 初期表示でエラーは出さない
 *  - 「カートに追加」「Shop Pay」どちらも常に押せる
 *  - 押下/送信時のみ検証し、未同意なら中断＋エラー表示
 *  - 同意後はそのまま進行（Shop Pay含む）
 */
(function () {
  'use strict';

  // ---------- 設定 ----------
  var PRODUCT_SCOPE_SELECTOR = '.product__info-container';
  var GROOVY_CONTAINER_SELECTOR = '.groovyco-form-generated';
  var REQUIRED_LABEL_KEYWORD = '（必須）';
  var PER_ITEM_ERROR_TEXT = 'この項目にチェックを入れてください。';
  var GLOBAL_ERROR_TEXT = '必須項目への同意チェックが未選択です。すべての「（必須）」にチェックを入れてください。';

  // ---------- util ----------
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function inProductScope(node) { return !!(node && node.closest && node.closest(PRODUCT_SCOPE_SELECTOR)); }
  function productScope(node) { return (node && node.closest && node.closest(PRODUCT_SCOPE_SELECTOR)) || $(PRODUCT_SCOPE_SELECTOR); }

  function setGlobalError(form, message) {
    var pf = form.closest('.product-form');
    if (!pf) return;
    var wrapper = pf.querySelector('.product-form__error-message-wrapper');
    var label = pf.querySelector('.product-form__error-message');
    if (!wrapper || !label) return;
    if (message) {
      label.textContent = message;
      wrapper.hidden = false;
    } else {
      label.textContent = '';
      wrapper.hidden = true;
    }
  }

  function findGroovyContainerFor(form) {
    var scope = productScope(form) || document;
    return scope.querySelector(GROOVY_CONTAINER_SELECTOR) || null;
  }

  function clearItemErrors(container) {
    if (!container) return;
    $all('.groovyco-error', container).forEach(function (el) { el.textContent = ''; });
  }

  // showErrors=false の場合は画面に何も出さない
  function renderItemErrors(invalidItems, showErrors) {
    if (!showErrors) return;
    invalidItems.forEach(function (item) {
      var keyNormalized = item.labelText.replace(/\s+/g, '');
      var errEl =
        item.el.querySelector('.groovyco-error[data-key="' + keyNormalized + '"]') ||
        item.el.querySelector('.groovyco-error[data-key]') ||
        item.el.querySelector('.groovyco-error');
      if (errEl) errEl.textContent = PER_ITEM_ERROR_TEXT;
    });
  }

  /**
   * 同意チェック検証
   * @param {HTMLFormElement} form
   * @param {boolean} showErrors - この呼び出しで可視エラーを出すか
   */
  function validateGroovyChecks(form, showErrors) {
    var container = findGroovyContainerFor(form);
    if (!container) return { ok: true, invalidItems: [] };

    if (showErrors) clearItemErrors(container);

    var checkboxes = $all('.groovyco-element.groovyco-checkbox input[type="checkbox"]', container);
    var invalid = [];

    checkboxes.forEach(function (input) {
      var el = input.closest('.groovyco-element.groovyco-checkbox');
      if (!el) return;
      var labelEl = el.querySelector('label');
      var labelText = (labelEl && labelEl.innerText ? labelEl.innerText : '').trim();
      var isRequired = labelText.indexOf(REQUIRED_LABEL_KEYWORD) !== -1;
      if (isRequired && !input.checked) {
        invalid.push({ input: input, el: el, labelText: labelText });
      }
    });

    renderItemErrors(invalid, showErrors);
    return { ok: invalid.length === 0, invalidItems: invalid };
  }

  function focusFirstInvalid(invalidItems) {
    if (!invalidItems.length) return;
    var el = invalidItems[0].el;
    var input = invalidItems[0].input;
    (el || input).scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { input && input.focus && input.focus({ preventScroll: true }); } catch (_) {}
  }

  // そのフォームで一度でもユーザーが操作済みか
  function markInteracted(form) { form.dataset.gcInteracted = '1'; }
  function hasInteracted(form) { return form.dataset.gcInteracted === '1'; }

  // ---------- ガード（商品ページ内のみ） ----------
  // submit（Enter対策含む）を最上流で止める
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('.product-form')) return;
    if (!inProductScope(form)) return;

    // 「カートに追加」用フォームに限定（installment等は除外）
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

    markInteracted(form);
    var result = validateGroovyChecks(form, /*showErrors=*/true);
    if (!result.ok) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      setGlobalError(form, GLOBAL_ERROR_TEXT);
      focusFirstInvalid(result.invalidItems);
    } else {
      setGlobalError(form, '');
    }
  }, true); // capture:true

  // クリック（「カートに追加」「Shop Pay」）を最上流で止める
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!inProductScope(target)) return;

    // .product__info-container 内のボタン領域のみ対象
    var buttonsWrap = target.closest('.product-form__buttons');
    if (!buttonsWrap) return;

    // 紐づくフォーム（add-to-cart）を取得
    var pf = buttonsWrap.closest('.product-form');
    var form = pf && pf.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    // 「カートに追加」 or 「.shopify-payment-button（Shop Pay等）」のみ検証対象
    var isSubmitBtn = !!(target.closest('button[type="submit"]'));
    var isAcceleratedArea = !!(target.closest('.shopify-payment-button'));
    if (!isSubmitBtn && !isAcceleratedArea) return;

    markInteracted(form);
    var result = validateGroovyChecks(form, /*showErrors=*/true);
    if (!result.ok) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      setGlobalError(form, GLOBAL_ERROR_TEXT);
      focusFirstInvalid(result.invalidItems);
    } else {
      setGlobalError(form, '');
      // 進行を妨げない（Shop Payも直接進行）
    }
  }, true); // capture:true

  // チェック状態の変更：一度でも操作済みのフォームのみエラー更新（初期は無表示）
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || target.type !== 'checkbox') return;
    if (!inProductScope(target)) return;

    var form = target.closest('.product-form form[data-type="add-to-cart-form"]');
    if (!form) return;

    if (hasInteracted(form)) {
      var result = validateGroovyChecks(form, /*showErrors=*/true);
      if (result.ok) setGlobalError(form, '');
    }
  });

  // 初期ロード時は何もしない（評価も表示もしない）
})();
